import React, { useEffect } from "react";
import { Grid, Typography, Card, Button, TextField } from "@mui/material";
import colors from "../../../../colors";
import { texts } from "../../../../general/texts";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from "react-router";
import { useState } from "react";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles } from "@mui/styles";
import Switch from '@mui/material/Switch';
import ConfirmDonation from "./ConfirmDonation";
import ThankYouDialog from "./ThankYouDialog";
import { useDispatch, useSelector } from "react-redux";
import { sendGeneralRequest } from '../../../../../features/generalRequest'
import { selectGlobalDataState } from "../../../../../features/global/globalDataSlice";
import { selectBasicAccountState, setShouldBasicAccountPaymentRun, setTransactionIdToCancel } from "../../../../../features/basicAccount/basicAccountSlice";
import { selectUserInfo } from "../../../../../features/userInfo/userInfoSlice";
import { runBasicAccountPayment } from "../../../../general/BasicAccountMethods";
import { selectUtilityState, setIsScaCompleted, setScaRequired } from "../../../../../features/utilities/utilitySlice";
import { determineTransactionRequest } from "../DetermineTransactionRequest";

const FshatiSos = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [amount, setAmount] = useState('')
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const [checked, setChecked] = useState(true);
    const [transID, setTransID] = useState('');
    const [confirmDonation, setConfirmDonation] = useState(false);
    const [thankYouDialog, openThankYouDialog] = useState(false);
    const classes = useStyles();
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const userInfoSliceState = useSelector(selectUserInfo)
    const basicAccountSliceState = useSelector(selectBasicAccountState)
    const utilitySliceState = useSelector(selectUtilityState)
    const transactionRequest = determineTransactionRequest(utilitySliceState.pin, 'FshatiSOS', globalDataSliceState.token, '',  utilitySliceState, '', amount, checked) 

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

   useEffect(() => {
  if (utilitySliceState.isScaRequired && utilitySliceState.isScaCompleted) {
    setConfirmDonation(true)
    dispatch(setScaRequired(false));
    dispatch(setIsScaCompleted(false));
  }
}, [utilitySliceState.isScaCompleted]);

    const startTransactionFshatiSos = () => {
        const formattedAmount = parseFloat(amount)
        dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, value: formattedAmount, anonymous: checked }, baseUrlKey: 'services', endpoint: 'FshatiSOS/StartTransactionFshatiSos' })).then(response => {
            if (response.payload.response.success) {
                setTransID(response.payload.response.transID)
                if (!response.payload.response.isScaRequired){
                    setConfirmDonation(true)
                }
            }
        })
    }

    const handleClose = (event) => {
        setConfirmDonation(false);
        openThankYouDialog(false);
        navigate(-1);
    };

    const confirmDonationApi = () => {
        if (userInfoSliceState.accountType === 3) {
            dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, paymentMethod: '2', applicationID: 1, value: amount.replace(/[^.\d]/g, ''), transID: transID }, baseUrlKey: 'services', endpoint: 'startCreditCardPayment' }))
            dispatch(setTransactionIdToCancel(transID))
        }
        else {
            dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, transID: transID }, baseUrlKey: 'services', endpoint: 'FshatiSOS/ConfirmTransactionFshatiSos' })).then(response => {
                if (response.payload.response.success) {
                    setConfirmDonation(false);
                    openThankYouDialog(true);
                }
            })
        }
    }

    const onBack = () => 
    {
        dispatch(setShouldBasicAccountPaymentRun(false))
    }


    return (
        <>
            {
                basicAccountSliceState.shouldBasicAccountPaymentRun
                    ?
                    runBasicAccountPayment(
                        dispatch,
                        basicAccountSliceState.basicAccountPaymentUrl,
                        { request: transactionRequest.confirmTransaction, baseUrlKey: 'services', endpoint: transactionRequest.endpoints.confirm },
                        { request: { token: globalDataSliceState.token, orderId: utilitySliceState.transactionId }, baseUrlKey: 'services', endpoint: 'cancelCreditCardPayment' },
                        onBack
                    )
                    :
                    <Grid container item md={12} xs={12} justifyContent={"center"} pt={"2%"}>
                        <Card
                            sx={{
                                borderRadius: "20px",
                                boxShadow: "0 0 15px 5px #E5E7EA",
                                padding: "20px",
                                background: colors.white,
                                display: 'flex',
                                flexDirection: 'column',
                                width: "620px",
                                minHeight: "65vh",
                                "@media (max-width: 899px)": { width: "80%" },
                            }}
                        >
                            <ArrowBackIosIcon color="warning" onClick={() => navigate(-1)} style={{ alignSelf: 'flex-start', fontSize: '20px', cursor: 'pointer' }} />
                            <div style={{ margin: '0 35px', display: 'flex', flexDirection: 'column' }}>
                                <p style={{ alignSelf: 'flex-start', fontSize: '28px', fontFamily: 'GerberaBold', color: colors.orange, margin: '0px', marginBottom: '25px' }}>{texts['title-donation-value']}</p>
                                <Grid container item md={12} xs={12}  >
                                    <TextField onChange={(e) => setAmount(e.target.value)} value={amount} type="number" color='warning' size='large' label={texts["placeholder-enter-amount"]} style={{ width: '100%' }} InputProps={{ style: { backgroundColor: '#FDFEFC' } }} inputProps={{ min: 1 }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: colors.lightOrange,
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: colors.orange,
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: colors.orange,
                                                },
                                            },
                                            marginBottom: '25px'
                                        }} />
                                    <div style={{ display: 'flex', flexDirection: isSmallScreen ? 'column' : 'row', width: '100%', justifyContent: isSmallScreen ? 'center' : 'space-between', marginBottom: '25px' }}>
                                        <div onClick={() => setAmount(1000)} style={{ width: isSmallScreen ? '100%' : '150px', marginBottom: isSmallScreen ? '25px' : '', height: '98px', border: amount === 1000 ? '2px solid #F3A967' : '1px solid #FDEBE0', backgroundColor: '#FDFEFC', borderRadius: '10px', color: amount === 1000 ? colors.orange : colors.darkBlue, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                                            <p><strong>1000</strong> ALL</p>
                                        </div>
                                        <div onClick={() => setAmount(3000)} style={{ width: isSmallScreen ? '100%' : '150px', marginBottom: isSmallScreen ? '25px' : '', height: '98px', border: amount === 3000 ? '2px solid #F3A967' : '1px solid #FDEBE0', backgroundColor: '#FDFEFC', borderRadius: '10px', color: amount === 3000 ? colors.orange : colors.darkBlue, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                                            <p><strong>3000</strong> ALL</p>
                                        </div>
                                        <div onClick={() => setAmount(5000)} style={{ width: isSmallScreen ? '100%' : '150px', height: '98px', border: amount === 5000 ? '2px solid #F3A967' : '1px solid #FDEBE0', backgroundColor: '#FDFEFC', borderRadius: '10px', color: amount === 5000 ? colors.orange : colors.darkBlue, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                                            <p><strong>5000</strong> ALL</p>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: isSmallScreen ? 'column' : 'row', width: '100%', justifyContent: 'space-between', marginBottom: '25px' }}>
                                        <div onClick={() => setAmount(7000)} style={{ width: isSmallScreen ? '100%' : '150px', marginBottom: isSmallScreen ? '25px' : '', height: '98px', border: amount === 7000 ? '2px solid #F3A967' : '1px solid #FDEBE0', backgroundColor: '#FDFEFC', borderRadius: '10px', color: amount === 7000 ? colors.orange : colors.darkBlue, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                                            <p><strong>7000</strong> ALL</p>
                                        </div>
                                        <div onClick={() => setAmount(9000)} style={{ width: isSmallScreen ? '100%' : '150px', marginBottom: isSmallScreen ? '25px' : '', height: '98px', border: amount === 9000 ? '2px solid #F3A967' : '1px solid #FDEBE0', backgroundColor: '#FDFEFC', borderRadius: '10px', color: amount === 9000 ? colors.orange : colors.darkBlue, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                                            <p><strong>9000</strong> ALL</p>
                                        </div>
                                        <div onClick={() => setAmount(10000)} style={{ width: isSmallScreen ? '100%' : '150px', height: '98px', border: amount === 10000 ? '2px solid #F3A967' : '1px solid #FDEBE0', backgroundColor: '#FDFEFC', borderRadius: '10px', color: amount === 10000 ? colors.orange : colors.darkBlue, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                                            <p><strong>10.000</strong> ALL</p>
                                        </div>
                                    </div>
                                    <div style={{ marginBottom: '25px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                                        <Typography style={{ color: colors.darkBlue, fontSize: '18px', fontFamily: 'GerberaBold' }}>{texts['title-donate-anonymus']}</Typography>
                                        <div>
                                            <Switch checked={checked} onChange={handleChange} color="warning" />
                                        </div>
                                    </div>
                                    <Button disabled={amount <= 0 || amount === ''} onClick={startTransactionFshatiSos} className={classes.button}>{texts['button-donate']}</Button>
                                </Grid>
                            </div>
                            <ConfirmDonation isDialogOpened={confirmDonation} amount={amount} handleClose={handleClose} confirmDonation={confirmDonationApi} />
                            <ThankYouDialog isDialogOpened={thankYouDialog} handleClose={handleClose} />
                        </Card>
                    </Grid>
            }
        </>

    );
}
const useStyles = makeStyles({
    button: {
        width: "100%",
        color: colors.white,
        fontSize: "1rem",
        textTransform: "none",
        background: colors.gradientOrange,
        fontFamily: "GerberaBold",
        border: 'none',
        cursor: 'pointer',
        borderRadius: '10px',
        height: '70px'
    }
});

export default FshatiSos;
